<template>
  <div class="">
    <div
        :class="
                'inline text-[32px] font-bold tracking-tighter' +
                ' ' +
                cssClasses
            "
    >
      {{ text }}
    </div>
  </div>
</template>

<script>
export default {
  name: "cms-header",
  props: {
    text: {
      type: String,
      default: "",
    },
    cssClasses: {
      type: String,
      default: "",
    },
  },
};
</script>
